export interface NavItem {
  to: string;
  label: string;
  icon: string;
  /** badge source: 'alarms' => live count; number => static */
  badge?: 'alarms' | number;
}

/** The 12 primary modules, in the exact order of the reference sidebar. */
export const NAV: NavItem[] = [
  { to: '/', label: '数据驾驶舱', icon: 'dashboard' },
  { to: '/dashboard', label: '自定义看板', icon: 'grid' },
  { to: '/hang', label: '吊养监控', icon: 'hang' },
  { to: '/makeup', label: '源水与补水', icon: 'source' },
  { to: '/utilities', label: '公辅', icon: 'utility' },
  { to: '/alarms', label: '报警中心', icon: 'alarm', badge: 'alarms' },
  { to: '/production', label: '生产管理', icon: 'production' },
  { to: '/recipes', label: '配方管理', icon: 'recipe' },
  { to: '/ai', label: 'AI 与科研', icon: 'ai' },
  { to: '/report', label: '报表构建器', icon: 'compliance' },
  { to: '/compliance', label: '合规导出', icon: 'compliance' },
  { to: '/lab', label: '化验闭环', icon: 'lab' },
  { to: '/equipment', label: '设备管理', icon: 'equipment' },
  { to: '/app', label: 'APP 端示意', icon: 'mobile', badge: 3 },
];
